import React, { useEffect, useState, useMemo } from "react";
import { Popover, Dropdown, Tag } from "antd";
// import AttachmentBox from "../AttachmentBox/AttachmentBox";
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import { markUnmarkFavourite, editQuestionText, FetchForceReroute, askClarificationExpert, getQuestionDraftData, getExpertOpenPageData } from "../../API/api";
// import Button2 from "../Button2/Button2";
import Button2 from "../../NewComponent/Button2/Button2";
import { DeleteOutlineOutlined, EditOutlined, FavoriteBorderOutlined, LocalFireDepartment, PeopleAltOutlined, HelpOutline, CheckCircleOutline } from "@mui/icons-material";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
// import Tags from "../answerBox/ExpertQA/Tags";
import Tags from "./Tags";
import { momentit } from "../../utils";
import { toast } from 'react-toastify';
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from "../../NewComponent/Button/Button";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import { handleError } from "../../utils";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Countdown from 'react-countdown';
import { ReactComponent as HeartIcon } from "../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../Icons/heartSelect.svg";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";







export default function QuestionBox({ data }) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { getScrollPositionInExpertOpen, openQuestionsData, advanceFilterModalToggle, getSelectedQuestion, deleteSelectedOpenQuestionUuid, getDomainOfQuestion, getSelectedQuestionDataExpert, getForceRerouteUsersStatus, updatePageNumberExpertOpenTab, refreshExpertOpenTabData, getExpertRequestUuid, questionDataForEditor, getSeekerAttachment, updateSubmissionTypeForEditor, updateAttachmentForEditor, updateAnswerTextForEditor, recommendData, isDataLoadingExpertOpen, getOpenDataCountExpert, getExpertOpenData, getIsOpenedQuestion } = bindActionCreators(Actions, dispatch)
	const [isFavorite, setFavorite] = useState(data.favourite);
	const openState = useSelector((state) => state.openQuestions)
	const [edit, setEdit] = useState(false)
	const [editQuestion, setEditQuestion] = useState(data.questionText)
	const [addditionalContext, setAdditionalContext] = useState(data.additionalContext && data.additionalContext !== '' ? data.additionalContext : '')
	const [clarified, setClarified] = useState(false)
	const [checkQuestionValue, setCheckQuestionValue] = useState('');
	const userState = useSelector((state) => state.user);
	const [domainId, setDomainId] = useState(null);
	const expertState = useSelector((state) => state.expertOpenData);
	const [clarificationText, setClarificationText] = useState('');
	const [clarifyButton, setClarifyButton] = useState(false);
	const [isFavourite, setIsFavourite] = useState(data.favourite);
	const startDate = React.useRef(data.expireSLA * 1000 + Date.now());
	const [expireSLA, setExpireSLA] = useState(data.expireSLA);
	const recommendState = useSelector((state) => state.recommend);
	  const editorState = useSelector((state) => state.editor);
	const time = useMemo(() => {
		return (data.expireSLA * 1000 + Date.now())
	}, [expireSLA]);



	const isButtonDisabled = data.clarificationStatus
		? (data.questionText === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '' || addditionalContext === ''
		: editQuestion === '';

	const containerStyle = {
		border: "1px solid #E0E2E6",
		borderRadius: "16px",
		background: "#FFFFFF",
		boxShadow: "0px 4px 16px 0px #1018280F",
		// padding: "24px 36px 24px 36px",
		padding: "28px",
		minHeight: "100px",
		marginBottom: '24px'
	};

	const onClickEdit = () => {
		setEdit(!edit)
	}

	const onClickCancel = () => {
		// setClarifyButton(!clarifyButton);
		setEdit(!edit)
	}

	const openModalToggle = () => {
		advanceFilterModalToggle({ bool: true, value: "expertOpen" })
		getSelectedQuestionDataExpert(data);
	}

	const handleShare = () => {
		openModalToggle()
		// setAnchorEl(null)
		getScrollPositionInExpertOpen(window.scrollY)
	}

	const onClickSubmitClarification = () => {
		const payload = {
			clarificationQuestion: clarificationText,
			questionUuidStr: data.questionUuid
		}
		askClarificationExpert(payload).then((res) => {
			if (res === undefined) return;
			if (res.data.success || res.data.data !== '') {
				setClarifyButton(!clarifyButton);
				setEdit(false);
				// getExpertData(filteredData);
				setClarificationText('');
				callApi();
				// refreshExpertOpenTabData(Math.random() * 10);
				// updatePageNumberExpertOpenTab(0)
				// refreshExpertOpenTabData(Math.random() * 10)
				toast.success(successfulClarificationQuestion(), {
					position: toast.POSITION.TOP_RIGHT,
					icon: false
				});
			}
		})
	}

	const successfulClarificationQuestion = () => {
		return (
			<>
				<div style={{ display: 'flex', alignItems: 'start' }}>
					<CheckCircleIcon style={{ color: '07bc0c', padding: '3px', fontSize: '32px' }} />
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<span style={{ fontSize: "13px", fontWeight: "bold" }}>Great!</span>
						<span style={{ fontSize: "11px" }}>
							Your request for clarification has been forwarded to the seeker
						</span>
					</div>
				</div>
			</>
		);
	};


	const renderAttachemnt = (arr) => {
		return (
			<div>
				{arr.map((item, index) => (
					<div className="mb-1">
						{" "}
						<AttachmentBox key={index} attachment={item} />
					</div>
				))}
			</div>
		);
	};



	const items = [
		...(data.questionStatus === 'answered'
			? [
				{
					key: '1',
					label: (
						<a onClick={() => handleShare()}>
							<ShareIcon style={{ paddingRight: '5px' }} />
							Share
						</a>
					),
				},
				{
					type: 'divider', // Keep this divider for separation
				},
			]
			: []),
		{
			key: '2',
			label: (
				<a onClick={() => onClickMarkFavorite(data.favourite)}>
					{data.favourite ? <HeartSelectedIcon /> : <HeartIcon />}
					&nbsp;Favourite
				</a>
			),
		},
	];
	const DropdownComponent = ({ question }) => {
		return (
			<>
				<Dropdown menu={{ items: items }}>
					<img src={require('../../Images/dots-vertical.png')} style={{ cursor: 'pointer' }} />
				</Dropdown>
			</>
		)
	}

	const onCLickFavorite = (key, flag) => {
		if (key === undefined) return
		markUnmarkFavourite(key.questionUuid).then((res) => {
			if (res === undefined) return;
			setFavorite(flag);
			let newOpenData = openState.openData.filter(obj => {
				if (obj.questionUuid === key.questionUuid) {
					obj.favourite = flag
				}
				return obj
			})
			openQuestionsData(newOpenData)
		});
	};

	const infoContainer = {
		display: "flex",
		alignItems: "center",
	};
	const dateInfoStyles = {
		// width: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "baseline",
		// marginBottom:'5px'
		// paddingLeft: "7px",

	};
	const textStyles = {
		fontSize: "21px",
		color: "#2A364A",
		lineHeight: "32px",
		fontWeight: "400",
		wordBreak: "break-word",
		// width:'100%',
	};

	const buttonStyles = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
		color: 'rgb(255, 255, 255)',
		border: '1px solid rgb(255, 255, 255)',
		height: '40px',
		minWidth: '88px',
		background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
		marginBottom: '14px',
		// opacity: (editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext) ? '0.34' : null,
		// opacity:data.clarificationStatus ? ((data.text === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '') ? '0.34' : (editQuestion === '') ? '0.34' : null : false,
		// cursor:(editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext || data.additionalContext === '')  ? 'not-allowed' : 'pointer'
		opacity: isButtonDisabled ? '0.34' : null,
		cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
	}

	const buttonStylesCancel = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
		color: 'black',
		border: '1px solid rgb(224, 226, 230)',
		height: '40px',
		minWidth: '88px',
		background: '#fff',
		marginBottom: '14px',
	}

	const renderToast = (message) => {
		return (
			<>
				<span style={{ fontSize: '12px' }}>
					{message}
				</span>
			</>
		)
	}

	const callApi = () => {
		getExpertOpenPageData(
			expertState.pageNo,
			expertState.sortFilterVal.origValue,
			expertState.sortFilterVal.sortOrder,
			expertState.sortChange,
			expertState.domainFilter,
			expertState.ownRecords
		).then((res) => {
			isDataLoadingExpertOpen(true);
			if (res === undefined) return;
			if (res.data.success === true || res.data.data !== "") {
				getExpertOpenData(res.data.data);
				getOpenDataCountExpert(res.data.count);
				isDataLoadingExpertOpen(false);
				// getIsOpenedQuestion(true)
			}
		});
	}



	const onClickUpdateButton = () => {

		const payload = {
			questionUuid: data.questionUuid,
			questionText: editQuestion,
			domain: data.domain,
			postedDate: data.postedTimestamp,
			additionalContext: addditionalContext
		}
		editQuestionText(payload).then((res) => {
			if (res === undefined) return
			if (res.data.success) {
				// let newData = openState.openData.filter((obj, ind) => {
				// 	if (obj.questionUuid === data.questionUuid) {
				// 		obj.text = editQuestion
				// 		if (obj.additionalContext) {
				// 			obj.additionalContext = addditionalContext
				// 			return obj;
				// 		}
				// 		return obj;
				// 	}
				// })
				let newData = [...openState.openData]
				newData.filter((obj, ind) => {
					if (obj.questionUuid === data.questionUuid) {
						obj.text = editQuestion
						obj.additionalContext = addditionalContext
						if (obj.clarificationStatus) {
							obj.clarificationStatus = false;
							setClarified(true)
							return obj;
						}
					}
				})
				openQuestionsData(newData)
				toast.success(renderToast(res.data.message), {
					position: toast.POSITION.TOP_RIGHT,
				});
				setEdit(false)
			}
		})
	}

	const onClickDeleteButton = () => {
		advanceFilterModalToggle({ bool: true, value: "deleteQuestion" });
		getSelectedQuestion(data);
		deleteSelectedOpenQuestionUuid(data.questionUuid);
	};

	const onClickWatchlistModal = (data) => {
		advanceFilterModalToggle({ bool: true, value: 'addToWatchlistOpenTab' });
		getSelectedQuestion(data);
	}

	const additionalContextStyles = {
		border: '1px solid rgb(246, 247, 248)',
		marginBlock: '10px',
		borderRadius: '6px',
		background: 'rgb(246, 247, 248)',
		padding: '12px',
		minHeight: '48px',
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap'
	}

	const clarificationBoxStyles = {
		background: '#f9ede5',
		padding: '5px 10px',
		borderRadius: '4px',
		marginBottom: '12px'
	}

	const onButtonCancel = () => {
		setEdit(false)
		setEditQuestion(data.questionText)
		setAdditionalContext(data.additionalContext)
	}

	const onClickClarificationButton = () => {
		setEdit(!edit);
	}

	const showOtherAnswer = () => {
		let obj = {
			type: 'answered',
			quesUuid: data.questionUuid,
			isUrlRedirection: true
		}
		recommendData(obj);
		navigate('/expertHome/recommend');
		getScrollPositionInExpertOpen(window.scrollY)
	}

	const onClickMarkFavorite = (flag) => {
		let filteredData = expertState.openPageData.filter((dat) => {
			if (dat.questionUuid === data.questionUuid) {
				dat.favourite = !flag;
			}
			return dat;
		});
		markUnmarkFavourite(data.questionUuid).then((res) => {
			if (res === undefined) return;
			// getExpertOpenData(filteredData);
			setIsFavourite(!isFavourite);
		}).catch(err => handleError(err));
	}

	const QuestionTextComponent = () => {
		return (
			<>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
					<div style={textStyles}>
						{/* {data.userInitiatedCuration && data.text.length < 43 && (
							<Tag color={'#6c94ba'} style={{fontWeight:'bold'}}>Requested Update</Tag>
						)} */}

						{data.express && (
							<>
								<FireIcon style={{ marginRight: '5px' }} />
							</>
						)}
						{data.questionStatus === 'answered' &&
							<TooltipComp title={"View other Expert's Answer"} children={<FontDownloadIcon sx={{ marginRight: "3px", cursor: "pointer", marginBottom: '3px' }} onClick={() => showOtherAnswer()} style={{
								color: "#BEDB39",
								fontSize: "22px"
							}} />} />}
						{
							data?.agenticId !== undefined &&
							<span style={{ color: "#ff8000", fontSize: "20px", paddingRight: "5px" }}>Briefing Agent AI Generated Document - Expert Review</span>

						}
						{/* <span style={{ coloCuration Status:r: "#ff8000", fontSize: "20px", paddingRight: "5px" }}>Briefing Agent AI Generated Document - Expert Review::</span> */}
						{data.questionText}
						{/* {data.userInitiatedCuration && data.text.length > 43 && (
							<Tag color={'#6c94ba'} style={{fontWeight:'bold',display:'inline-block',marginLeft:'5px'}}>Requested Update</Tag>
						)} */}
						{/* {data.clarificationStatus && data.text.length > 43 && (
							<>
								<Tag onClick={() => setEdit(true)} color={'#fd7400'} icon={<HelpOutline style={{ marginRight: '5px', fontSize: '18px' }} />} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Expert requested for clarification</Tag>
							</>
						)} */}
					</div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{/* {
							clarified && (
								<Tag style={{fontWeight:'bold',backgroundColor:'green',color:'white'}} icon={<CheckCircleOutline style={{ marginRight: '5px', fontSize: '18px', fontWeight: 'bold' }} />}>Request Clarified</Tag>
							)
						} */}
						{/* {data.clarificationStatus && data.text.length < 43 && (
							<>
								<Tag onClick={() => setEdit(true)} color={'#fd7400'} icon={<HelpOutline style={{ marginRight: '5px', fontSize: '18px' }} />} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Expert requested for clarification</Tag>
							</>
						)} */}
						{/* {data.seekerAttachments && data.seekerAttachments.length > 0 && (
							<Popover title={renderAttachemnt(data.seekerAttachments)}>
								{" "}
								<div style={{marginRight:'7px'}}>
								<Button2 onClickFunc={onCLickFavorite}>
									<DownloadIcon />
								</Button2>
								</div>
							</Popover>)} */}
						{data.questionStatus === 'answered' && expertState.ownRecords && <DropdownComponent />}
						{expertState.ownRecords === false && (
							data.favourite ? <HeartSelectedIcon style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite(data.favourite)} /> : <HeartIcon style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite(data.favourite)} />
						)}
						{expertState.ownRecords && data.questionStatus !== 'answered' && (
							data.favourite ? <HeartSelectedIcon style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite(data.favourite)} /> : <HeartIcon style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite(data.favourite)} />
						)}
					</div>
				</div>
			</>
		)
	}

	const onClickReroute = () => {
		getScrollPositionInExpertOpen(window.scrollY)
		getDomainOfQuestion(data.domain);
		getSelectedQuestionDataExpert(data.questionUuid);
		FetchForceReroute(data.questionUuid, domainId).then((res) => {
			if (res === undefined) return;
			if (res.data.success === true || res.data.data !== '') {
				advanceFilterModalToggle({ bool: true, value: "rerouteModal" })
				getForceRerouteUsersStatus(res.data.data);
			}
		})
	}

	const onChangeClarificationText = (e) => {
		setClarificationText(e.target.value);
	}

	const onClickModalDecline = () => {
		getScrollPositionInExpertOpen(window.scrollY)
		advanceFilterModalToggle({ bool: true, value: "expertDecline" });
		getExpertRequestUuid(data.expertRequestUuid);
	}

	const onClickAnswerNow = (data) => {
		getScrollPositionInExpertOpen(window.scrollY)
		getSeekerAttachment(data.seekerAttachments)
		questionDataForEditor(data);
		updateSubmissionTypeForEditor('answer');
		if (data.attachments !== undefined) {
			updateAttachmentForEditor(data.attachments);
		}
		// if(data.draftExists){
		getQuestionDraftData(data.questionUuid).then(res => {
			if (res === undefined) return;
			if (res.data.data.length > 0) {
				updateAnswerTextForEditor(res.data.data[0].answer);
				navigate('/expertHome/editor');
			} else {
				updateAnswerTextForEditor('');
				navigate('/expertHome/editor');
			}
		})
		//   }

	}

	// const renderer = ({ days, hours, minutes, seconds, completed }) => {
	// 	data.expireSLA = data.expireSLA - 1;
	// 	if (completed) {
	// 		//   setIsTime(true);
	// 		getSelectedQuestion(data.questionUuid);
	// 		// let newArr = expertState.openPageData.filter((obj) => {
	// 		// 	if (obj.questionUuid !== data.questionUuid) {
	// 		// 		return obj;
	// 		// 	}
	// 		// })
	// 		// getExpertOpenData(newArr);
	// 		// let newCount = expertState.openCount - 1;
	// 		// getOpenDataCountExpert(newCount);
	// 		callApi();
	// 		// element.scrollIntoView({ behaviour: 'smooth' })
	// 		//   setTimeout(() => function () {
	// 		// 	refreshExpertOpenTabData(Math.random() * 10);
	// 		// 	// return <Completionist />
	// 		//   }, 5000);
	// 	}
	// 	return (
	// 	  <>
	// 		<AccessTimeIcon sx={{ fontWeight: 'bold', fontSize: '21px', paddingRight: '3px', color: days === 0 && hours < 1 && minutes < 6 ? "red" : "green" }} />
	// 		{/* <span className="countdown" style={{ fontSize: "14px", color: hours < 1 && minutes < 5 ? "red" : "green" }}>
	// 		  {hours > 24 && zeroPad(days)}{hours > 24 && "d"}{hours >= 1 && zeroPad(hours)}{hours >= 1 && "h"}{hours >= 1 ? ":" : null}{zeroPad(minutes)}m{hours < 1 && ":"}{hours < 1 && zeroPad(seconds)}{hours < 1 && "s"}&nbsp;left</span></>); */}
	// 		<span style={{ fontSize: '15px',fontWeight:500, color: days === 0 && hours === 0 && minutes < 6 ? "red" : "green" }}>{days > 0 && days}{days > 0 && "d:"}{(days > 0 && hours)}{days > 0 && "h"}{(days === 0 && hours > 0 && hours)}{days === 0 && hours > 0 && "h:"}{days < 1 && minutes}{days < 1 && minutes && "m:"}{minutes < 1 && ":"}{((minutes < 60) && (days === 0)) && seconds}{((minutes < 60) && (days === 0)) && seconds && "s"}&nbsp;left</span>
	// 	  </>
	// 	)
	//   };

	const renderer = ({ days, hours, minutes, seconds, completed }) => {
		if (completed) {
			callApi();
			//   getSelectedQuestion(data.questionUuid);
		}

		return (
			<>
				<AccessTimeIcon
					sx={{
						fontWeight: 'bold',
						fontSize: '21px',
						paddingRight: '3px',
						color: days === 0 && hours === 0 && minutes < 6 ? "red" : "green"
					}}
				/>
				<span style={{ fontSize: '15px', fontWeight: 500, color: days === 0 && hours === 0 && minutes < 6 ? "red" : "green" }}>
					{days > 0 && `${days}d`}
					{days > 0 && hours > 0 && ':'}
					{hours > 0 && `${hours}h`}
					{(days > 0 || hours > 0) && minutes > 0 && ':'}
					{minutes > 0 && `${minutes}m`}
					{(days === 0 && hours === 0 && minutes < 60 && minutes >= 1) && `:`} {/* New condition for handling : */}
					{(days === 0 && hours === 0 && minutes < 60) && `${seconds}s`}
					&nbsp;left
				</span>
			</>
		);
	};


	useEffect(() => {
		setExpireSLA(data.expireSLA);
		let i = userState.expertTopics.filter((obj) => {
			if (obj.name === data.domain) {
				setDomainId(obj.indexId);
				return obj;
			}
		});
	}, [data.expireSLA])

	const renderer2 = ({ days, hours, minutes, seconds, completed }) => {
		if (completed) {
			return <span>Countdown!!</span>
		}
		return (
			<><span>{days}:{hours}:{minutes}:{seconds}</span></>
		)
	}

	return (
		<>
			<div style={containerStyle}>
				{/* {edit && data.clarifications && data.clarifications.length > 0 && (
					<>
						<div style={clarificationBoxStyles}>
							<span className="clarificationHeading">Clarification request from expert <span className="clarificationHeadingSubText">(Clarify question to allow an expert to provide the best answer)</span></span>
							<ul>
								{data.clarifications.map((obj, ind) => {
									return (
										<><li key={ind}>{obj.context}</li></>
									)
								})}
							</ul>
						</div>
					</>
				)} */}
				{edit === false && <QuestionTextComponent />}
				{edit &&
					(
						<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							{
								data.express && <FireIcon style={{ marginRight: '4px' }} />
							}
							<div style={{ width: '100%' }}>
								<div style={textStyles}>
									{data.questionText}
								</div>
							</div>
						</div>
					)}
				{edit === false && data.additionalContext && data.additionalContext !== '' && (
					<>
						<div style={additionalContextStyles}>
							{data.additionalContext}
						</div>
					</>
				)}
				{/* {
					data.seekerAttachments && data.seekerAttachments.length > 0 && edit &&
					<div style={{ marginTop: '10px', width: '52px' }}>
						{
							<Popover title={renderAttachemnt(data.seekerAttachments)}>
								{" "}
								<Button2 onClickFunc={onCLickFavorite}>
									<DownloadIcon />
								</Button2>
							</Popover>
						}
					</div>
				} */}
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<span style={{ color: '#5C667B', fontWeight: 400, fontSize: '14px', marginTop: '5px', marginBottom: '5px' }}>Asked{" "}{momentit(data.questionPostedTimestamp)}</span>
					<div>
						{expertState.ownRecords === true && data.expireSLA > 0 && <><Countdown
							renderer={renderer} ref={startDate} date={time} >
						</Countdown></>}
					</div>
				</div>
				{(
					<>
						<Tags edit={edit} setEdit={setEdit} data={data} clarified={clarified} />
					</>
				)}
				{/* Primary buttons with blue gradient for Answer Now, Update Answer, and Verify Now */}
				{
					edit === false && (
						<>
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'flex-end' }}>
								{userState.reroute && expertState.ownRecords === true &&
									// <RerouteButton onClick={() => onClickReroute()} ><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</RerouteButton>
									<Button2 minWidth={'140px'} type="dark" children={<span><i className="fa fa-repeat" style={{ marginRight: '5px' }} />Reroute</span>} onClickFunc={onClickReroute} />
								}
								{data.questionStatus !== 'answered' && (data.clarificationStatus === false || data.clarifications.length === 0) && (
									<>
										{/* <RequestClarification onClick={() => onClickClarificationButton()}><i className="fa fa-question-circle" style={{ paddingRight: '5px' }}></i>Request Clarification</RequestClarification> */}
										<Button2 minWidth={'140px'} type="dark" onClickFunc={onClickClarificationButton} children={<span><i style={{ marginRight: '5px' }} className="fa fa-question-circle" />Request Clarification</span>} />
									</>)
								}
								{expertState.ownRecords === true &&
									//  <DeclineButton onClick={() => onClickModalDecline()} ><i className="fa fa-times" style={{ paddingRight: '5px' }}></i>Decline</DeclineButton>
									<Button2 minWidth={'140px'} type="dark" onClickFunc={onClickModalDecline} children={<span><i className="fa fa-times" style={{ paddingRight: '5px' }} />Decline</span>} />
								}
								{((data.userInitiatedCuration === false && data.docId === undefined) && data.docId === undefined &&
									//  <AnswerNowButton onClick={() => onClickAnswerNow(data)}><i className="fa fa-comment-o" style={{ paddingRight: '5px' }}></i>Answer Now</AnswerNowButton>
									<Button text={<span><i className="fa fa-comment-o" style={{ paddingRight: '5px' }} />Answer Now</span>} onClickFunc={() => onClickAnswerNow(data)} type="primary" />
								)
								}
								{((data.userInitiatedCuration === true && data.docId === undefined) && data.docId === undefined &&
									// <UpdateAnswerButton onClick={() => onClickAnswerNow(data)}>Update Answer</UpdateAnswerButton>
									<Button text={<span>< i className="fa fa-lightbulb-o" style={{ paddingRight: '5px' }} />Update Answer</span>} onClickFunc={() => onClickAnswerNow(data)} type="primary" />

								)}
								{(data.docId !== undefined && <Button type={'primary'} text={<span><i className="fa fa-check" style={{ paddingRight: '5px' }} />Verify Now</span>} onClickFunc={() => onClickAnswerNow(data)} />)}
								{/* <Button2 minWidth={'140px'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-check" style={{ paddingRight: '5px' }} />Verify Now</span>} type={'primary'} />
								: data.userInitiatedCuration ?
																	// <UpdateAnswerButton onClick={() => onClickAnswerNow(data)} >Update Answer</UpdateAnswerButton>
								<Button2 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span>
									<i className="fa fa-lightbulb-o" style={{ paddingRight: '5px' }} />Update Answer
								</span>} /> */}
							</div>
						</>
					)
				}
				{
					edit &&
					<div className="row">
						<div className="col-md-12">
							{/* <div className="clarifyBoxExpert"> */}
							<span style={{ fontSize: "14px" }}></span>
							{data.clarifications && data.clarifications.length > 0 &&
								<>
									<ul style={{ listStyle: "square" }}>
										{data.clarifications.map((cla) => {
											return (<li style={{ color: "rgb(253, 74, 0)", fontSize: "14px" }}>{cla.context}</li>)
										})}
									</ul>
								</>}
							<textarea placeholder="Ask your clarification to question here" value={clarificationText} onChange={(e) => onChangeClarificationText(e)} rows={5} style={{ borderRadius: '6px', resize: 'none', padding: '10px', width: "100%", fontSize: "14px", outline: "none", border: "1px solid lightgray", marginTop: '5px', marginBottom: '10px' }}></textarea>
							{/* <button className="btn-warning submitButtonExpert" disabled={clarificationText === '' ? true : false} onClick={() => onClickSubmitClarification()} >Submit</button> */}
							<div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '12px' }}>
								{/* <button className="btn-warning submitButtonExpert" onClick={() => onClickCancel()} >Cancel</button> */}
								<Button type={'secondary'} onClickFunc={onButtonCancel} text={'Cancel'} />
								{clarificationText === '' ? <span style={{ opacity: 0.5, pointerEvents: 'none' }}>
									<Button type={'primary'} onClickFunc={onClickSubmitClarification} text={'Submit'} />
								</span> : <Button type={'primary'} onClickFunc={onClickSubmitClarification} text={
									'Submit'
								} />}
							</div>
							{/* </div> */}
						</div>
					</div>
				}
			</div>
		</>
	)
}